/**
 * atomberg-thumbnail-drag-scroll.js
 * ───────────────────────────────────
 * Progressive enhancement for Horizon's native PDP media gallery thumbnail
 * strip (`.slideshow-controls__thumbnails-container`) — adds mouse
 * drag-to-scroll matching the ETR carousel and PDP color tiles. Does not
 * modify the Horizon component; only attaches behavior from the outside.
 * Requires atomberg-drag-scroll.js to load first.
 *
 * Horizon swaps the gallery markup on variant change (see
 * atomberg-product-variant-picker.js updateGallery), so re-scans on
 * `atomberg:pdp-variant-change` to wire up the replacement thumbnail strip.
 */
(function () {
  /** @type {any} */
  var w = window;
  if (w._atombergThumbnailDragScrollInit) return;
  w._atombergThumbnailDragScrollInit = true;

  var wired = /** @type {any} */ (typeof WeakSet !== 'undefined' ? new WeakSet() : null);

  function wireThumbnails() {
    if (!w.AtombergDragScroll) return;
    document.querySelectorAll('.slideshow-controls__thumbnails-container').forEach(function (el) {
      if (wired && wired.has(el)) return;
      if (wired) wired.add(el);
      w.AtombergDragScroll.enable(/** @type {HTMLElement} */ (el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireThumbnails);
  } else {
    wireThumbnails();
  }

  document.addEventListener('atomberg:pdp-variant-change', wireThumbnails);
})();
